import React from "react"
import { Outlet } from "react-router-dom"
import Header from "../components/Header"
import bg from "../images/bg.svg"
const Creator = () => (
  <React.Fragment>
    <div
      className="leading-normal tracking-normal text-gray-900 h-screen pb-14 bg-right bg-cover"
      style={{ backgroundImage: `url(${bg})` }}
    >
      {/* Template Header */}
      <Header />

      <div className="w-full px-1 text-gray-700 antialiased font-[inter]">
        <div className="content py-5">
          <Outlet />
        </div>
      </div>
    </div>
  </React.Fragment>
)

export default Creator
